import { useRouter } from 'next/router';
import { FC, useState } from 'react';
import OverviewNav from '../../../common/OverviewNav';
import { tabsValues } from '../../../config/pageConfig';
import Bundles from '../Bundles';
import StreamAcPro from './StreamAcPro';
import StreamSeries from './StreamSeries';
import StreamUltra from './StreamUltra';

interface IProps {
    isLogin?: boolean;
}

const formal: FC<IProps> = () => {
    const { query } = useRouter();
    const searchTab = query?.tab;
    let defaultTab = 'Overview';
    const defaultPage = 'stream';
    if (typeof searchTab === 'string' && tabsValues.includes(searchTab)) {
        defaultTab = searchTab;
    }
    const [activeTab, setActiveTab] = useState(defaultTab);
    const [activePage, setActivePage] = useState(defaultPage);

    return (
        <>
            <OverviewNav
                activeTab={defaultTab}
                onChange={(val) => {
                    setActivePage(val);
                    setActiveTab(defaultTab);
                    window.scrollTo(0, 0);
                }}
                onTabChange={(val) => setActiveTab(val)}
            />
            {activeTab === 'Overview' && activePage === 'stream' && <StreamSeries />}
            {activeTab === 'Overview' && activePage === 'streamUltra' && <StreamUltra />}
            {activeTab === 'Overview' && activePage === 'streamAcPro' && <StreamAcPro />}
            {/* {activeTab === 'Bundles' && <Bundles />} */}
        </>
    );
};
export default formal;
